// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Config } from "../config";
import { ApplicationFeature, UpdateApplicationFeature } from "./types/applicationFeatureTypes";

const apiManagementRootUrl: string | undefined = Config.REACT_APP_CCL_API_MANAGEMENT_URL;

// Define a service using a base URL and expected endpoints
export const cclTokenedApplicationFeaturesApi = createApi({
    reducerPath: "cclTokenedApplicationFeaturesApi ",
    tagTypes: ["users", "Features"],
    baseQuery: fetchBaseQuery({
        baseUrl: apiManagementRootUrl,
        prepareHeaders: (headers, { getState }) => {
            //we should probably change this.
            const token = localStorage.getItem("token") as string;
            headers.set("authorization", `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAllApplicationFeatures: builder.query<ApplicationFeature[], void>({
            query: () => ({
                url: "ccl-access2-data/v1.0/ApplicationFeatures/features",
                method: "GET",
            }),
            providesTags: ["Features"],
        }),
        getApplicationFeatureWithId: builder.query<ApplicationFeature, number>({
            query: (id) => ({
                url: `ccl-access2-data/v1.0/ApplicationFeatures/features/${id}`,
                method: "GET",
            }),
            providesTags: ["Features"],
        }),
        updateApplicationFeature: builder.mutation<boolean, UpdateApplicationFeature>({
            query: (args) => ({
                url: "ccl-access2-data/v1.0/ApplicationFeatures/features/update",
                method: "POST",
                body: args,
            }),
            invalidatesTags: ["Features"],
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetAllApplicationFeaturesQuery,
    useGetApplicationFeatureWithIdQuery,
    useUpdateApplicationFeatureMutation,
} = cclTokenedApplicationFeaturesApi;
